// Web has no push channel for standby (app-only feature); the entries screen
// still renders on web (must not crash), so this is a deliberate no-op rather
// than importing `expo-notifications`.
export const useStandbyEntriesPushRefetch = (): void => {};
